import { render, staticRenderFns } from "./TabStock.vue?vue&type=template&id=80af9b96"
import script from "./TabStock.vue?vue&type=script&lang=js"
export * from "./TabStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports